<template>
  <div class="freightPolicy">
    <div class="freightPolicy-content">
      <h3>运费收取规则：</h3>
      <ul>
        <li>
          1）特殊商品：该类商品运费收取适用在其详情页公示的特殊规则。如商品详情页无特殊规则，则适用本运费规则。
        </li>
        <li>
          2）普通商品：订单（不含特殊商品、服务类商品及其他非实物商品）含税金额满300元免收运费；不满300元的，偏远地区（新疆维吾尔自治区、内蒙古自治区、宁夏回族自治区、西藏自治区、青海省、海南省、港澳台）按照50元/单收取运费，除偏远地区外的其他国内地区按照15元/单收取运费。
        </li>
        <li>
          3）同一订单中既包括普通商品又包括特殊商品的，两类商品按照其对应的运费收取规则分别计算，互不叠加。
        </li>
        <li>4）服务类商品及其他非实物商品订单免收运费。</li>
        <li>注1：计算运费的订单金额以订单最终实际支付金额为准。</li>
        <li>
          注2：运费的收取规则可能进行相应调整，具体以商品详情页及官网公示为准。
        </li>
      </ul>
      <h3>针对退换货的运费：</h3>
      <ul>
        <li>
          1）若退换货是由工自仪原因导致，则针对退换货部分的来回运费由工自仪承担；
        </li>
        <li>
          2）若退换货是由客户原因导致，则针对退换货部分的来回运费由客户自行承担；(若仅退货，则仅需要承担退回部分运费）
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.freightPolicy {
  width: 100%;
  .freightPolicy-content {
    width: 1200px;
    margin: 0 auto;
    padding: 30px;
    h3 {
      margin-top: 20px;
    }
    li {
      margin-bottom: 10px;
    }
  }
}
</style>
